import {atom, useAtomValue} from 'jotai';

import {OmicronContent, OmicronFlags} from '@web-catalog/api/omicronApi';
import {OmicronConfigSchema} from '@web-catalog/api/omicronApi/types';

import {getDefaultConfig} from '@utils/omicron';

export const omicronConfigAtom = atom(
  getDefaultConfig<OmicronContent>(OmicronConfigSchema),
);

export const useSafeOmicronFlag = <T extends OmicronFlags>(flag: T) => {
  const config = useAtomValue(omicronConfigAtom);
  return config[flag];
};
